"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendEmailCodeRequest = void 0;
var SendEmailCodeRequest = /** @class */ (function () {
    function SendEmailCodeRequest() {
    }
    return SendEmailCodeRequest;
}());
exports.SendEmailCodeRequest = SendEmailCodeRequest;
;
//# sourceMappingURL=sendEmailCode.request.js.map